export default __webpack_public_path__ + "static/media/locked-img.1036ac0d.svg";